import {
    AllResultsWithCostDropdownItem,
    mapLimitedListOfItemsToTopNWithCost,
    TopNWithCostDropdownItem,
} from "app/pages/sales-intelligence/common-components/table-actions-panel";
import getLimitedListOfItems from "app/pages/sales-intelligence/modules/quota/utils/getLimitedListOfItems";
import {
    NO_TOUCH_USER_REVEAL_DROPDOWN_ITEMS_LIST,
    NO_TOUCH_USER_REVEAL_DROPDOWN_MAX_ITEM,
    REVEAL_DROPDOWN_ITEMS_LIST,
    REVEAL_DROPDOWN_MAX_ITEM,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/revealDropdownItemsList";

import {
    generateValuesBasedOnLimit,
    getItemWithTheSmallestValueOrManual,
} from "../../../../table-actions-panel/utils/selection-dropdown";
import { CONTACTS_SEARCH_TABLE_PAGE_SIZE } from "../../../constants/table";

function generateValues(maximumValue: number) {
    const values = generateValuesBasedOnLimit(maximumValue, [0.25, 0.5]);
    const [quarter] = values;

    if (quarter >= 100) {
        return [50, ...values];
    }

    return values;
}

function getValuesForDataCredits(
    numberOfResults: number,
    remainingRevealQuota: number,
    contactsCost: number,
    isNoTouchUser: boolean,
): readonly TopNWithCostDropdownItem[] {
    const availableItems = getLimitedListOfItems(
        isNoTouchUser ? NO_TOUCH_USER_REVEAL_DROPDOWN_ITEMS_LIST : REVEAL_DROPDOWN_ITEMS_LIST,
        remainingRevealQuota,
        contactsCost,
        numberOfResults,
        isNoTouchUser ? NO_TOUCH_USER_REVEAL_DROPDOWN_MAX_ITEM : REVEAL_DROPDOWN_MAX_ITEM,
        false,
    );

    return mapLimitedListOfItemsToTopNWithCost(availableItems);
}
function getValuesForQuota(numberOfResults: number, remainingRevealQuota: number): readonly TopNWithCostDropdownItem[] {
    const maximumValue = Math.min(numberOfResults, remainingRevealQuota, 1300);

    if (maximumValue <= CONTACTS_SEARCH_TABLE_PAGE_SIZE) {
        return [new AllResultsWithCostDropdownItem({ value: maximumValue, cost: 1, isAvailable: true })];
    }

    const items = generateValues(maximumValue).map((value) => ({ value }));

    return items.map(
        ({ value }) => new TopNWithCostDropdownItem({ id: `top-${value}`, value, cost: 1, isAvailable: true }),
    );
}

const revealSelectionDropdown = {
    getInitiallySelectedItem: getItemWithTheSmallestValueOrManual,
    createItems(
        numberOfResults: number,
        remainingRevealQuota: number,
        contactsCost: number,
        isDataCreditsEnabled: boolean,
        isNoTouchUser: boolean,
    ): readonly TopNWithCostDropdownItem[] {
        return isDataCreditsEnabled
            ? getValuesForDataCredits(numberOfResults, remainingRevealQuota, contactsCost, isNoTouchUser)
            : getValuesForQuota(numberOfResults, remainingRevealQuota);
    },
};

export default revealSelectionDropdown;
